/**
 * This is the forgotten routes configuration.
 * Only configure routes in this file.
 * @memberOf Forgotten Module
 * @namespace Forgotten Routes
 */
import forgottenTemplate from './forgotten.html';

/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf Forgotten Module.Forgotten Routes
 * @ngInject
 */
var config = function ($stateProvider) {

    /* Create the forgotten state and assign the template and controller. */
    $stateProvider
		.state('login.forgotten', {
			url: '/forgotten',
			template: forgottenTemplate,
			controller: 'forgottenController',
			controllerAs: 'forgottenController'
		});
}

export default config;



// WEBPACK FOOTER //
// ./src/login/forgotten/forgotten.route.js